export const firebaseConfig = {
  apiKey: "AIzaSyC4svHFXTig8yP1jOdj0-jr9DkywrbGgrE",
  authDomain: "haii-d-prj-tess.firebaseapp.com",
  projectId: "haii-d-prj-tess",
  storageBucket: "haii-d-prj-tess.appspot.com",
  messagingSenderId: "587234296171",
  appId: "1:587234296171:web:e4f36cbef3e656e4570c2e",
  measurementId: "G-1QEBN4XGRJ",
};
